import React, { createContext, useState } from 'react';

export const OmeMeetAthleteEntryFiltersStateContext = createContext();

const INITIAL_STATE = {
  filterObject: {},
  sortBy: ''
};

const OmeMeetAthleteEntryFiltersContextProvider = ({ children }) => {
  const stateHook = useState(INITIAL_STATE);

  return (
    <OmeMeetAthleteEntryFiltersStateContext.Provider value={stateHook}>
      {children}
    </OmeMeetAthleteEntryFiltersStateContext.Provider>
  );
};

export default OmeMeetAthleteEntryFiltersContextProvider;